import "esbuild-css-modules-plugin-ns-css:src/js/components/exportButton/exportButton.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/exportButton/exportButton.module.css:injector.js";
export default new Proxy({
  "button": "exportButton-module__button_sb7T0G__1100",
  "buttonText": "exportButton-module__buttonText_sb7T0G__1100",
  "icon": "exportButton-module__icon_sb7T0G__1100",
  "iconAndTextWrapper": "exportButton-module__iconAndTextWrapper_sb7T0G__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      